<template>
    <div class="modal-container has-text-centered" style="overflow: auto">
         <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
        <div class="has-text-dark  bottom20">
           <div class="top40"> <div class="is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/>
           <span class="left2 has-text-white">{{createOrEdit == 'create' ? 'NEW' : 'EDIT'}} PAGE</span></div></div>
            <br>
            <!-- <div ref="pName" class="editCardTitle is-size-5 has-text-left title" contenteditable="true" @keydown.enter="save($event)"  v-text="pageName"></div> -->
            <input ref="pName" type="text" class="input" placeholder="PAGE NAME" v-model="pageName" />

           
            
            <!-- <div v-show="pageType == 1" ref="slug" class="editCardTitle is-size-5 has-text-left title" contenteditable="true" @keydown.enter="save($event)"  v-text="slug"></div> -->
            <input v-show="!protectedPages.includes(slug)" ref="slug" type="text" class="input top20" placeholder="SLUG" v-model="slug" />
            <div v-show="showAlert" class="has-text-danger is-size-6">{{message}}</div>

            <!-- <div v-show="showPlaceholder" class="has-text-left" style="margin: 0 50px 0 55px; position: relative; top: 3px; color: #888">Name</div> -->
        </div>

        <div v-if="isLanding" class="has-text-left has-background-dark pad10">
            <b>Select Position:</b>
             <helpTree2 class="top10"
                :item= tree[0] 
                :depth=0
                >
            </helpTree2>
        </div>

        <div class="has-text-danger">{{err}}</div>
        <button class="button is-small top10 is-coolGreen wideButton" @click="save">SAVE</button><br>
        <div class="cancelButton  top10" @click="cancel">Cancel</div>
         <div v-show="createOrEdit == 'edit'" class="top10 has-text-centered">
            <div v-show="(!sure && createOrEdit == 'edit')" class="cancelButton has-text-grey" @click="sure = true">Delete</div>
            <span v-show="sure" class="has-text-white is-size-7"><b>Are you sure? </b>&nbsp;<button class="button is-coolGreen tiny" @click="deletePage">YES</button> <button class="button tiny" @click="sure = false">NO</button></span>
        </div>
        <div>&nbsp;</div>
    </div>
</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import Tree4Bundles from '../components/Tree4Bundles'
import helpTree2 from '../components/helpTree2.vue'

export default{
    components: {Tree4Bundles, helpTree2},
    props: {
        createOrEdit: {
            type: String,
            default: 'create'
        },

        pageName: {
            type: String,
            default: '',
            
        },

        item: {
            type: Object,
            default: function(){ return {}}
        },

        index: {
            type: Number,
            default: null
        },

        isLanding: {
            type: Number,
            default: 0
        },
        tree: {
            type: Array,
            default: [{name: ''}]
        }, slug: {
            type: String,
            default: ''
        },
        pageType: {
            type: Number,
            default: 1
        }

    },
    data: function(){
       return {
          //pageName: '',
          showPlaceholder: !this.pageName.length ? false : true,
          sure: false,
          posParent: null,
          posIndexId: null,
          topOrBot: null,
          err: '',
          message: '',
          protectedPages: ['discover', 'help', 'faq', 'about', 'newroom', 'press']

       }
    },

   

    mounted: function(){
        if(this.createOrEdit == 'edit'){
            //this.pageName = this.item.name
            //this.$refs.pName.innerText = this.item.name

            //find tree node and select it
            AZEventBus.$emit('cmsAutoSelectNode', {parent: this.item.parent, id: this.item.id})
           
        }

        this.pageName = this.item.name;
        this.slug = this.item.code;

        if(this.item.isLanding){
            this.posIndexId = this.item.id
            this.posParent = this.item.parent
        }

    /*     AZEventBus.$on('parentSelected', msg => {
            this.parent = msg.id
        }) */

        AZEventBus.$on('indexSelected', this.indexSelectedHandler)
    },

    beforeDestroy: function(){
       

        AZEventBus.$off('indexSelected', this.indexSelectedHandler)
    },

    methods: {

        indexSelectedHandler: function(msg){
            this.posIndexId = msg.id
            this.posParent = msg.parent
            this.topOrBot = msg.topOrBot
            this.err = ''
        },


        save: function(e){
            e.stopPropagation()
            e.preventDefault()
            var self = this;

            if(this.slug.split(' ').length > 1){
                self.message = 'No spaces or special characters are allowed'
                self.showAlert = true
                return
            }

            
            function w(d){
                if(d == 'slug exists'){
                    self.message = 'This slug already exists.'
                    self.showAlert = true
                    return
                }
                
                self.$root.app.$refs.routerView.loadPages() //addPage({name: self.$refs.pName.innerText, id: d.id, isLanding: self.isLanding})
                self.$emit('close')
            }

            function n(){

            }
            
            function w2(d){

                if(d == 'slug exists'){
                    self.message = 'This slug already exists.'
                    self.showAlert = true
                    return
                }

                self.$root.app.$refs.routerView.loadPages()   //self.$root.app.$refs.routerView.updateName({name: self.$refs.pName.innerText, index: self.index, isLanding: self.isLanding, id: self.item.id})
                self.$emit('close')
            }

            function n2(){

            }

            if(this.createOrEdit == 'create'){
                if(!this.posParent && this.isLanding){
                    this.err='Please select a position for the page'
                    return
                }

                //If creating a new child instead of sibling, pass itself as the parent
                if(this.topOrBot == 2)
                    this.posParent = this.posIndexId

                this.$root.app.apiClient.post('subs/data/page', {name: self.pageName, isLanding: self.isLanding, posParent: this.posParent, posIndexId: this.posIndexId, topOrBot: this.topOrBot, code: this.slug}, w, n)

            } else if(this.createOrEdit == 'edit'){

                //If creating a new child instead of sibling, pass itself as the parent
                if(this.topOrBot == 2)
                    this.posParent = this.posIndexId

                this.$root.app.apiClient.put('subs/data/page', {name: self.pageName, isLanding: self.isLanding, id: self.item.id, posParent: this.posParent, posIndexId: this.posIndexId, topOrBot: this.topOrBot, currParent: this.item.parent, code: this.slug}, w2, n2)
            }
            
        },

        cancel: function(){

            this.$emit('close')
        },

        deletePage: function(){
            if((this.item.isLanding && this.item.id == process.env.VUE_APP_ROOT_HELP) || (!this.item.isLanding && this.item.id == process.env.VUE_APP_ROOT_DISCOVER)){
                this.$root.app.showModalOK({message: 'You may not delete the root page of this section'})
                return
            }
           
            
            var self = this
            function w(d){
                self.$root.app.$refs.routerView.loadPages() //self.$root.app.$refs.routerView.deletePage(self.index, self.isLanding)
                self.$emit('close')
            }

            function n(){

            }

            this.$root.app.apiClient.delete('subs/data/page', {id: this.item.id, currParent: this.item.parent, isLanding: this.item.isLanding}, w, n)
        },
        cancel: function(){
            this.$emit('close')
        },

       
    }

 
}

</script>

<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }

    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
    input{
        background-color: #333;
        border: none;
        border-bottom: 1px solid #f1c232;
        color: white;
        max-width: 320px
    }

    input::placeholder{
        color: #888
    }

</style>